import {Component, Input, OnInit} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FileLink} from 'src/app/services/api/api';

@Component({
  selector: 'sb-comp-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
  standalone: false,
})
export class ImageViewerComponent implements OnInit {
  @Input() src: string | FileLink | null = null;
  @Input() title: string | null = null;
  @Input() modalRef: NgbModalRef = null;

  constructor(public modal: NgbModal) {}

  ngOnInit() {}

  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }
}
